import {feed_fetchFeedByContainer_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import {renderEmptyHolder} from 'components/EmptyHolder'
import Pure from 'components/Pure'
import _ from 'lodash'
import {permissionCodes} from 'modules/permissions/contants'
import PermissionProvider from 'modules/permissions/PermissionProvider'
import React, {useContext, useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {nest} from 'recompose'
import EntityList from 'views/AppLocals/EntityList'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {renderFeedItem} from 'views/MainPage/functions/renderFeedItem'
import {NullAsDefault, renderIf} from 'views/Shared'
import CourseClassContext from '../../CourseClassContext'
import CourseClassPostInputBar from './CourseClassPostInputBar'

// Composer dùng CourseClassPostInputBar (avatar + input + hàng 3 icon: Bình chọn / Bài viết /
// Hỏi đáp) - giống GenericPostForm mặc định nhưng KHÔNG có Ý nguyện. Xem comment đầu
// CourseClassPostInputBar.js.
const CourseClassNews = ({Footer = NullAsDefault}) => {
    const location = useLocation()

    const {refreshToken} = location.state ?? {}

    const {item} = useContext(CourseClassContext)

    const apiInfo = feed_fetchFeedByContainer_Api

    const [id, prop] = [getId(item), getType(item)]

    const refreshKey = useMemo(
        () =>
            [
                apiInfo?.path?.replace(':id', id)?.replace(':prop', prop),
                `refreshToken=${refreshToken}`,
            ].join('?'),
        [id, prop, refreshToken]
    )

    const {channel, available_actions} = item ?? {}

    const container = {
        id: getId(channel),
        type: getType(channel),
    }

    return renderIf(
        item,
        <div className="space-y-3 w-full">
            <PermissionProvider
                permissions={{
                    [permissionCodes.canPost]: _.get(
                        available_actions,
                        permissionCodes.canPost
                    ),
                }}>
                <CourseClassPostInputBar container={container} defaultChannel={item?.channel}/>
            </PermissionProvider>
            <EntityList
                key={refreshKey}
                apiInfo={apiInfo}
                refreshKey={refreshKey}
                renderItem={renderFeedItem}
                RenderEntity={React.Fragment}
                renderEmpty={renderEmptyHolder}
                query={bindQueryParams([{id}, {prop}])}
                renderWrap={(child, __, count) => (
                    <div className="space-y-3">
                        {child}
                        {count ? <Footer/> : null}
                        <div className="h-12"/>
                    </div>
                )}
            />
        </div>
    )
}

export default nest(Pure, CourseClassNews)
